<div class="row pt-4">
  <div class="col-md-4">
    <dl>
      <dt class="h3">
        {{ 'PROJECT_LEAD' | translate }}
      </dt>
      <dd>
        <app-profile-link
          [dataTestId]="'project-first-lead'"
          [status]="status"
          [userId]="entity.creator.user_id"
          [text]="entity.creator.displayed_name"
        ></app-profile-link>
      </dd>
    </dl>
    <dl *ngIf="entity.website">
      <dt class="h3">
        {{ 'PROJECT_WEBSITE' | translate }}
      </dt>
      <dd>
        <a data-test-id="project-website" [href]="normalizedLink" target="_blank">
          {{ entity.website }}
        </a>
      </dd>
    </dl>
    <dl>
      <dt class="h3">
        {{ 'PROJECT_LOCATION' | translate }}
      </dt>
      <dd data-test-id="project-location">
        <a
          class="d-inline-flex align-items-center"
          data-test-id="active-project-location"
          target="_blank"
          [routerLink]="['/map', mapFilters.PROJECTS.toLowerCase()]"
          [queryParams]="{ id: entity.entity_id }"
          [ngbTooltip]="'TOOLTIP_SEE_ON_MAP' | translate"
        >
          <svg-icon src="assets/icons/icon-map-pin.svg" class="icon-location-pin mb-1 mr-1"></svg-icon>
          <span class="mb-0">{{ location }}</span>
        </a>
      </dd>
    </dl>
    <dl>
      <dt class="h3">
        {{ 'PROJECT_TYPE' | translate }}
      </dt>
      <dd data-test-id="project-type">
        {{ entity.type }}
      </dd>
    </dl>
    <dl>
      <dt class="h3">
        {{ 'PROJECT_DISEASE_TYPE' | translate }}
      </dt>
      <dd data-test-id="project-diseases">
        <span [attr.data-test-id]="'project-diseases'">
          {{ entity['diseases'] | formatCategories }}
        </span>
      </dd>
    </dl>
    <dl>
      <dt class="h3">
        {{ 'PROJECT_SPECIALITIES' | translate }}
      </dt>
      <dd data-test-id="project-specialities">
        <span [attr.data-test-id]="'project-specialities'">
          {{ entity.specialities | formatCategories }}
        </span>
      </dd>
    </dl>
    <dl class="d-flex mb-0">
      <dl class="me-3">
        <dt class="h3">
          {{ 'PROJECT_START_DATE' | translate }}
        </dt>
        <dd data-test-id="project-start-date" class="mb-0">
          {{ entity['validity_period']['start_date'] | date: DATE_FORMAT_LONG }}
        </dd>
      </dl>
      <dl>
        <dt class="h3">
          {{ 'PROJECT_END_DATE' | translate }}
        </dt>
        <dd data-test-id="project-end-date" class="mb-0">
          {{ entity['validity_period']['end_date'] | date: DATE_FORMAT_LONG }}
        </dd>
      </dl>
    </dl>
    <dl *ngIf="entity['funding_source']">
      <dt class="h3">
        {{ 'PROJECT_FUNDING_SOURCE' | translate }}
      </dt>
      <dd class="multi-line-text" data-test-id="project-funding-source">
        {{ entity['funding_source'] }}
      </dd>
    </dl>
    <dl *ngIf="entity['community']">
      <dt class="h3">
        {{ 'PROJECT_COMMUNITY' | translate }}
      </dt>
      <dd data-test-id="project-community">
        <a data-test-id="project-community" aria-label="Go to project community" [routerLink]="communityLink">
          {{ entity.community.title }}
        </a>
      </dd>
    </dl>
    <dl *ngIf="entity.linked_organizations?.length">
      <dt class="h3">
        {{ 'PROJECT_ORGANIZATIONS' | translate }}
      </dt>
      <dd class="comas" data-test-id="project-organizations">
        <app-view-profile-organization-links
          [organizationLink]="entity.linked_organizations"
          [fieldNumber]="0"
          [dataTestId]="'project-organization'"
          [shouldRedirectWhenNoSession]="true"
        >
        </app-view-profile-organization-links>
      </dd>
    </dl>
  </div>
  <div class="col-md-8">
    <p class="multi-line-text" data-test-id="project-description">
      {{ entity.description }}
    </p>
  </div>
</div>
